import { render, staticRenderFns } from "./LogoSmall.vue?vue&type=template&id=9da31f94&scoped=true"
import script from "./LogoSmall.vue?vue&type=script&lang=js"
export * from "./LogoSmall.vue?vue&type=script&lang=js"
import style0 from "./LogoSmall.vue?vue&type=style&index=0&id=9da31f94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da31f94",
  null
  
)

export default component.exports